import { mode } from "@chakra-ui/theme-tools";
const Card = {
  baseStyle: (props) => ({
    p: "20px",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    position: "relative",
    borderRadius: "8px",
    minWidth: "0px",
    wordWrap: "break-word",
    bg: mode("#ffffff", "navy.800")(props),
    backgroundClip: "border-box",
    border: "1px solid",
    borderColor: mode("#E6ECFA", "rgba(135, 140, 189, 0.3)")(props),
    boxShadow: mode(
      "0px 4px 12px rgba(112, 144, 176, 0.08)",
      "0px 4px 12px rgba(0, 0, 0, 0.2)"
    )(props),
  }),
};

export const CardComponent = {
  components: {
    Card,
  },
};
